/**
 * Échanges sur une demande de congé (employé ⇄ administrateur).
 *
 * Les messages sont ajoutés côté serveur par la route /repondre_demande_conge (data.js),
 * qui reçoit (chiffré) :
 *   { id_demande, auteur: "admin" | "user", nom, message, date }
 * et répond :
 *   { code: 0, message: "ok", data: { conversation: "<JSON du champ commentaire>" } }
 *   { code: -1, message: "<raison>" }
 * Voir docs/echanges-demandes.md.
 */
import engine from "@/core/index";
import { appendMessage, createMessage, parseCommentaire } from "@/core/commentaire";

// Passer à false pour masquer les réponses tant que la route serveur n'est pas déployée
export const ECHANGES_ACTIFS = true;

// Statuts sur lesquels l'échange reste ouvert : 0 = en attente, 4 = suppression demandée
export const STATUTS_ECHANGE_OUVERT = [0, 4];

export function echangeOuvert(request) {
  return ECHANGES_ACTIFS && !!request && STATUTS_ECHANGE_OUVERT.includes(parseInt(request.statut));
}

const ERREUR_GENERIQUE = "Le message n'a pas pu être envoyé. Réessayez dans un instant.";

// Interprète la réponse de la route /repondre_demande_conge
function lireResultat(data) {
  if (data && data.code == 0) {
    const conversation = data.data && data.data.conversation;
    return { ok: true, conversation };
  }
  // Les raisons renvoyées par le serveur (« Demande introuvable »…) sont affichées telles quelles
  const raison = data && typeof data.message === "string" ? data.message.trim() : "";
  return { ok: false, message: raison && raison !== "error" ? raison : ERREUR_GENERIQUE };
}

/**
 * Envoie un message dans la conversation d'une demande.
 * callback({ ok, commentaire, message }) :
 *   - ok : true si le message est enregistré ;
 *   - commentaire : nouvelle valeur du champ à afficher ;
 *   - message : explication en cas d'échec.
 */
export function envoyerMessage({ request, role, nom, texte }, callback) {
  if (!ECHANGES_ACTIFS) {
    callback({ ok: false, message: "Les échanges ne sont pas encore activés." });
    return;
  }

  const entree = createMessage(role, texte, { nom });
  const auteur = role === "admin" ? "admin" : "user";
  const params = {
    id_demande: request.id_demande,
    auteur,
    nom: entree.nom || "",
    message: entree[auteur],
    date: entree.date,
  };

  engine.repondre_demande_conge(params, (data) => {
    const res = lireResultat(data);
    if (!res.ok) {
      console.warn("repondre_demande_conge : échec", data);
      callback({ ok: false, message: res.message });
      return;
    }
    // Conversation renvoyée par le serveur si disponible, sinon ajout local du message
    const conversation = typeof res.conversation === "string"
      ? res.conversation
      : res.conversation ? JSON.stringify(res.conversation) : "";
    const commentaire = conversation && parseCommentaire(conversation).length
      ? conversation
      : appendMessage(request.commentaire, entree);
    callback({ ok: true, commentaire });
  });
}
